import React from 'react';
import { Layout } from "antd";

const { Footer: AntFooter } = Layout;

function Footer(){
  return(
    <AntFooter style={{ textAlign: 'center' }}>
      Ryo Calendar ©{new Date().getFullYear()} 
    </AntFooter>
  )
}

export default Footer
